import { LOCALES, Locale } from 'config/constants/locales';

export const URL_LOCALE_PREFIXES = [LOCALES.DE, LOCALES.EN, LOCALES.NL] as const;

export type UrlLocalePrefix = (typeof URL_LOCALE_PREFIXES)[number];

export const getUrlLocalePrefix = (locale?: string): UrlLocalePrefix | undefined => {
  const language = locale?.toLowerCase().split('-')[0];

  return URL_LOCALE_PREFIXES.find((prefix) => prefix === language);
};

export const getLocalePathPrefix = (
  locale?: string,
  defaultLocale: string = LOCALES.DE
): string => {
  const prefix = getUrlLocalePrefix(locale);
  const defaultPrefix = getUrlLocalePrefix(defaultLocale);

  return !prefix || prefix === defaultPrefix ? '' : `/${prefix}`;
};

export const getLocaleFromPathPrefix = (pathname: string): Locale | undefined => {
  const [firstSegment] = pathname.split(/[?#]/)[0].split('/').filter(Boolean);

  return getUrlLocalePrefix(firstSegment);
};
